export function formatearPesoMXN(numero: number) {
  const formateador = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return formateador.format(numero);
}

export const formatFechaMexico = (fechaString: string | Date) => {

  const date = new Date(fechaString);
  if (isNaN(date.getTime())) {
    return 'Fecha inválida'; 
  }

  const option: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'America/Mexico_City',
  };

  return new Intl.DateTimeFormat('es-MX', option).format(date);
};